import { EAttachmentFileType, EAttachmentType, type IAttachment, type IAttachmentTree } from 'findef'

import DirectoryIcon from 'assets/img/svg/icons/closed_folder.svg?url'
import DraftIcon from 'assets/img/svg/icons/draft.svg?url'
import CodeIcon from 'assets/img/svg/icons/code.svg?url'
import AudioIcon from 'assets/img/svg/icons/music_note.svg?url'
import VideoFileIcon from 'assets/img/svg/icons/video_file.svg?url'
import TableIcon from 'assets/img/svg/icons/table.svg?url'
import PDFIcon from 'assets/img/svg/icons/file-pdf.svg?url';
import ZipIcon from 'assets/img/svg/icons/file-zip.svg?url';
import TextIcon from 'assets/img/svg/icons/file-text.svg?url';

export const getAttachmentIconSource = (attach: Partial<IAttachment> | Partial<IAttachmentTree>) => {
  if (attach.type === EAttachmentType.DIRECTORY) return DirectoryIcon;

  if (attach.type === EAttachmentType.FILE && attach.name && attach.name.includes('.')) {
    const lower = attach.name.toLowerCase();
    const parts = lower.split('.');
    const ext = parts[parts.length-1];

    switch (ext) {
      case 'pdf':
        return PDFIcon;
    }
  }

  switch (attach.fileType) {
    case EAttachmentFileType.CODE:
      return CodeIcon
    case EAttachmentFileType.AUDIO:
      return AudioIcon
    case EAttachmentFileType.VIDEO:
      return VideoFileIcon
    case EAttachmentFileType.SPREADSHEET:
      return TableIcon
    case EAttachmentFileType.TEXT:
      return TextIcon;
    case EAttachmentFileType.PDF:
      return PDFIcon;
    case EAttachmentFileType.ARCHIVE_ZIP:
    case EAttachmentFileType.ARCHIVE_TAR:
    case EAttachmentFileType.ARCHIVE_TAR_GZ:
      return ZipIcon;
  }

  return DraftIcon
}
